import axiosInstance from './axiosInstance';

const BASE = (pid) => `/plants/${pid}/units`;

export const getUnits = async (pid, params) => {
  return await axiosInstance.get(BASE(pid), { params });
};

export const createUnit = async (pid, data) => {
  return await axiosInstance.post(BASE(pid), data);
};

export const updateUnit = async (pid, uid, data) => {
  return await axiosInstance.put(`${BASE(pid)}/${uid}`, data);
};

export const deleteUnit = async (pid, uid) => {
  return await axiosInstance.delete(`${BASE(pid)}/${uid}`);
};